// SolubilityCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Kelarutan - Hitung Kelarutan dalam Air";
const DESCRIPTION =
  "Gunakan Kalkulator Kelarutan untuk menghitung jumlah maksimum zat yang dapat dilarutkan dalam air. Ketahui perbedaan antara larutan jenuh dan tidak jenuh.";
const KEYWORDS =
  "kalkulator kelarutan, kelarutan, larutan jenuh, larutan tidak jenuh, kimia, hitung kelarutan, ilmu kimia";
const OG_URL = "https://do-calculate.com/calculator/id/solubility-calculator/";
function SolubilityCalculator() {
  const [firstValue, setFirstValue] = useState(0);
  const [secondValue, setSecondValue] = useState(0);
  const [result, setResult] = useState();
  const [steps, setSteps] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (firstValue && secondValue) {
        const solubility = (parseInt(firstValue) * 100) / parseInt(secondValue);
        setResult(solubility.toFixed(2));
        setSteps(`Untuk menghitung kelarutan:
        \n1. Kalikan massa zat terlarut dengan 100: ${firstValue} × 100 = ${
          firstValue * 100
        }
        \n2. Bagi hasilnya dengan massa air (pelarut): ${
          firstValue * 100
        } ÷ ${secondValue} = ${solubility.toFixed(2)}`);
        setError("");
      } else {
        setError(
          "Harap masukkan semua nilai yang diperlukan untuk melakukan perhitungan!"
        );
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini menghitung kelarutan menggunakan persamaan berikut:
                </p>
                <p>
                  <strong>
                    Kelarutan = Massa zat terlarut × 100 / Massa pelarut
                  </strong>
                </p>
                <ul>
                  <li>
                    Masukkan massa zat terlarut (padatan) yang ingin Anda larutkan.
                  </li>
                  <li>Masukkan massa air yang digunakan (pelarut).</li>
                </ul>
                <p>
                  Kalkulator ini dikembangkan untuk membantu Anda memahami sejauh mana suatu zat tertentu dapat larut dalam air, membantu Anda menentukan jenis larutan yang dihasilkan.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="firstValue">
                      <label className="form-label ms-2">
                        Masukkan massa zat terlarut (gram)
                      </label>
                      <input
                        id="firstValue"
                        type="number"
                        value={firstValue}
                        onChange={(e) => setFirstValue(e.target.value)}
                        placeholder="Masukkan massa zat terlarut"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="secondValue">
                      <label className="form-label ms-2">
                        Masukkan massa air (gram)
                      </label>
                      <input
                        id="secondValue"
                        type="number"
                        value={secondValue}
                        onChange={(e) => setSecondValue(e.target.value)}
                        placeholder="Masukkan massa air"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">Hasil:</h4>
                      <p className="text-white">{result}</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>Langkah Penyelesaian:</h4>
                        <p
                          className="text-black"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {steps}
                        </p>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Informasi Tambahan</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Jenis Larutan</h2>{" "}
                  </u>
                  <p>
                    Saat melarutkan zat padat dalam air, dua jenis larutan dapat terbentuk:
                  </p>
                  <ul>
                    <li>
                      <strong>Larutan Jenuh:</strong> adalah larutan yang tidak dapat melarutkan lebih banyak zat padat tanpa mengubah suhunya.
                    </li>
                    <li>
                      <strong>Larutan Tidak Jenuh:</strong> adalah larutan yang dapat melarutkan lebih banyak zat padat tanpa perlu perubahan suhu.
                    </li>
                  </ul>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Faktor-faktor yang Mempengaruhi Kelarutan
                    </h2>{" "}
                  </u>
                  <p>Kelarutan dipengaruhi oleh beberapa faktor, antara lain:</p>
                  <ul>
                    <li>Suhu</li>
                    <li>Sifat zat terlarut dan pelarut</li>
                    <li>Tekanan gas (dalam kasus larutan gas)</li>
                  </ul>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Pentingnya Kelarutan dalam Kehidupan Sehari-hari
                    </h2>{" "}
                  </u>
                  <p>
                    Kelarutan memainkan peran penting dalam banyak proses biologis dan industri seperti:
                  </p>
                  <ul>
                    <li>Pembuatan minuman dan obat-obatan</li>
                    <li>Pengolahan air</li>
                    <li>Berbagai industri kimia</li>
                  </ul>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>{" "}
                  </u>
                  <p>
                    Temukan jawaban untuk beberapa pertanyaan umum tentang kelarutan dan cara menghitungnya.
                  </p>
                  <b>Bagaimana cara meningkatkan kelarutan suatu zat dalam air?</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Anda dapat meningkatkan kelarutan dengan memanaskan air atau menambahkan pelarut lain.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default SolubilityCalculator;